import React, { useEffect, useState } from 'react';
import { getCollectionListbyWalletAddress } from '../../hooks/Collectionhook';
import { loadAllNFTs } from '../../assets/Data/NFT';
import { contractAddress } from '../../config/BackendUrl';
import { listNFTs } from '../../hooks/NFTHook';
import { useParams } from 'react-router-dom';

const SidebarProfile = (props) => {
  const UserData = props.user;
  const [collection, setCollection] = useState(0);
  const { walletAddress } = useParams();

  const [nfts, setNfts] = useState(0);

  const userAddress = localStorage.getItem("WalletAddress");;
  console.log("userAddress", userAddress, walletAddress);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch collections
        const Query = { ownerAddress: walletAddress === undefined ? userAddress : walletAddress }

        const data = await getCollectionListbyWalletAddress(Query);
        console.log("data at about", data.total, walletAddress);

        if (data.success) {
          setCollection(data.total);
        }
        const body = { ownerAddress: walletAddress === undefined ? userAddress : walletAddress  }
        const allNFTs = await listNFTs(body); // Fetch all NFTs
        console.log("Mkfdm", allNFTs);
        if (allNFTs.success) {
          const NFTs = allNFTs.data;

          // const userNFTs = NFTs.filter(nft => nft.creator === walletAddress); // Filter by user's wallet address
          setNfts(NFTs.length);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [walletAddress]);

  return (
    <div className="profile__sidebar">
      <div className="space-y-40">
        <div className="space-y-10">
          <h5>About me</h5>
          <div className="box space-y-20">
            <p>
              {UserData.bio}
            </p>
            <div className="row">
              <div className="col-6">
                <span className="txt_sm color_text">Collections</span>
                <h4>{collection}</h4>
              </div>
              <div className="col-6">
                <span className="txt_sm color_text">Creations</span>
                <h4>{nfts}</h4>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="space-y-10">
          <h5>Follow me</h5>
          <div className="box">
            <ul className="social_profile space-y-10 overflow-hidden">
              <li>
                <a href="https://www.facebook.com/" rel="noreferrer" target="_blank">
                  <i className="ri-facebook-line" />
                  <span className="color_text">facebook/</span>
                  @creabik
                </a>
              </li>
              <li>
                <a href="https://www.messenger.com/" rel="noreferrer" target="_blank">
                  <i className="ri-messenger-line" />
                  <span className="color_text"> messenger/</span>
                  @creabik
                </a>
              </li>
              <li>
                <a href="https://whatsapp.com" target="_blank" rel="noreferrer" >
                  <i className="ri-whatsapp-line" />
                  <span className="color_text"> whatsapp/</span>
                  @creabik
                </a>
              </li>
              <li>
                <a href="https://youtube.com" target="_blank" rel="noreferrer" >
                  <i className="ri-youtube-line" />
                  <span className="color_text">youtube/</span>
                  @creabik
                </a>
              </li>
            </ul>
          </div>
        </div> */}
      </div>
      <p className="text-center txt_sm mt-20 color_text">Since 2025</p>
    </div>
  );
};

export default SidebarProfile;
